import { subscribe } from 'infinite-ui-event';
import { useCallback, useEffect } from 'preact/hooks';

export function useUiEvent(eventType, callback, dependencies, options) {
	// The rule doesn't respect passing the dependencies and array in params
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const memoCallback = useCallback(callback, dependencies);

	useEffect(() => {
		const subscription = subscribe(eventType, memoCallback, options);

		return () => {
			subscription.unsubscribe();
		};
	}, [eventType, options, memoCallback]);
}
